<template>
  <div class="uk-width-expand@m" style="background-color: #1A4766">
    <div class="bb-preview" ref="bbPreview">
      <svg viewBox="0 0 1 1">
        <rect width="100%" height="100%" fill="#1A4766"></rect>
        <svg :viewBox="`0 0 ${viewBoxWidth} 100`" v-if="wallbedBlueprint != null">
          <g>
            <!-- left cabinet -->
            <image v-if="left_cabinet != null"
              :xlink:href="leftCabinetBlueprintImage"
              :width="leftCabinetProp('width')" :height="leftCabinetProp('height')"
              :x="leftCabinetPosition.x"
              :y="leftCabinetPosition.y"
              preserveAspectRatio="none"></image>
            <!-- transform="scale(-1, 1) translate(-32, 0)" -->
            <!-- wallbed cabinet -->
            <image :xlink:href="wallbedBlueprintImage"
            :width="wallbedProp('width')" :height="wallbedProp('height')"
            :x="wallbedPosition.x" :y="wallbedPosition.y" preserveAspectRatio="none"></image>
            <!-- right cabinet -->
            <image
              v-if="right_cabinet != null"
              :xlink:href="rightCabinetBlueprintImage"
              :width="rightCabinetProp('width')" :height="rightCabinetProp('height')"
              :x="rightCabinetPosition.x" :y="rightCabinetPosition.y"
              preserveAspectRatio="none"></image>
          </g>
          <!-- height left --> 
          <g>
            <path class="measurement-line" :d="measurementLeft.main"></path>
            <path class="measurement-line" :d="measurementLeft.top"></path>
            <path class="measurement-line" :d="measurementLeft.bottom"></path>
            <rect class="measurement-rect" :x="measurementLeft.rect.x" :y="measurementLeft.rect.y" width="4" height="20"></rect>
            <text class="measurement-text left" :x="measurementLeft.text.x" :y="measurementLeft.text.y" :transform="measurementLeft.text.transform" font-size="2.5pt">{{ measurementLeft.total | bluePrintMeasurement }}"</text>
          </g>
          <!-- width -->
          <g>
            <path class="measurement-line" :d="measurementWidth.main"></path>
            <path class="measurement-line" :d="measurementWidth.left"></path>
            <path class="measurement-line" :d="measurementWidth.right"></path>
            <rect class="measurement-rect" :x="measurementWidth.rect.x" :y="measurementWidth.rect.y" width="20" height="4"></rect>
            <text class="measurement-text" :x="measurementWidth.text.x" :y="measurementWidth.text.y" font-size="2.5pt">{{ measurementWidth.total | bluePrintMeasurement }}"</text>
          </g>
          <!-- right -->
          <g v-if="left_cabinet != null || right_cabinet != null">
            <path class="measurement-line"  :d="measurementRight.main"></path>
            <path class="measurement-line"  :d="measurementRight.top"></path>
            <path class="measurement-line"  :d="measurementRight.bottom"></path>
            <rect class="measurement-rect" :x="measurementRight.rect.x" :y="measurementRight.rect.y" width="4" height="20"></rect>
            <text class="measurement-text right" :x="measurementRight.text.x" :y="measurementRight.text.y" :transform="measurementRight.text.transform" font-size="2.5pt">{{ measurementRight.total | bluePrintMeasurement }}"</text>
          </g>
        </svg>
      </svg>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  export default {
    name: "builder-preview",
    components: {},
    data() {
      return {
        builder_padding : 40
      };
    },
    methods : {
      wallbedProp(prop){
        const blueprint = this.wallbedBlueprint;
        if(blueprint != null){
          return blueprint[prop];
        }
        return "";
      },
      leftCabinetProp(prop){
        if(this.left_cabinet == null) return 0;
        return this.left_cabinet[prop];
      },
      rightCabinetProp(prop){
        if(this.right_cabinet == null) return 0;
        return this.right_cabinet[prop];
      }
    },
    computed : {
      /**
       * wallbed width +
       * left cabinet width +
       * right cabinet width
       * @return {[type]} [description]
       */
      viewBoxWidth(){

        let width = parseFloat(this.wallbedProp('width')) + this.builder_padding;
        if(this.leftCabinetBlueprint != null) width += parseFloat(this.leftCabinetProp('width'));
        if(this.rightCabinetBlueprint != null) width += parseFloat(this.rightCabinetProp('width')); 
        return width;
      },
      /**
       * get wallbed blue print
       * @return {[type]} [description]
       */
      wallbedBlueprintImage(){
        const blueprint = this.wallbedBlueprint;
        if(blueprint != null){
          return blueprint.image.webPath;
        }
        return "";
      },
      /**
       * get the blueprint for the current bed size
       * check desk_table option to get right image
       * @return {[type]} [description]
       */
      wallbedBlueprint(){
        if(this.bed_size == null) return null;
        let blueprint = null;
        const fptid = (this.desk_table == null)? null : this.desk_table.front_panel_type.id;
        for(let i in this.bed_size.blueprints){
          const bp = this.bed_size.blueprints[i];
          if(bp.front_panel_type_id == fptid){
            blueprint = bp;
            break;
          }
        }
        return blueprint;
      },
      /**
       * loop through cabinet blue prints and match
       * on glass_door and nightstand
       * @return {[type]} [description]
       */
      leftCabinetBlueprint(){
        if(this.left_cabinet == null) return null;

        let blueprint = null;
        for(let i in this.left_cabinet.blueprints){
          const bp = this.left_cabinet.blueprints[i];
          if(bp.glass_doors == this.left_cabinet_glass_doors && bp.nightstand == this.left_cabinet_night_tray){
            blueprint = bp;
            break;
          }
        }
        return blueprint;
      },
      /**
       * loop through cabinet blue prints and match
       * on glass_door and nightstand
       * @return {[type]} [description]
       */
      rightCabinetBlueprint(){
        if(this.right_cabinet == null) return null;

        let blueprint = null;
        // to do : Glass cabinet or night stand?
        for(let i in this.right_cabinet.blueprints){
          const bp = this.right_cabinet.blueprints[i];
          if(bp.glass_doors == this.right_cabinet_glass_doors && bp.nightstand == this.right_cabinet_night_tray){
            blueprint = bp;
            break;
          }
        }
        return blueprint;
      },
      /**
       * get left cabinet blue print image
       * @return {[type]} [description]
       */
      leftCabinetBlueprintImage(){
        const blueprint = this.leftCabinetBlueprint;
        if(blueprint != null){
          return `${blueprint.image.webPath}?x-invert=1`;
        }
        return "";
      },
      /**
       * get right cabinet blue print image
       * @return {[type]} [description]
       */
      rightCabinetBlueprintImage(){
        const blueprint = this.rightCabinetBlueprint;
        if(blueprint != null){
          return blueprint.image.webPath;
        }
        return "";
      },
      /**
       * calculate the x and y position of the wallbed blueprint
       * @return {[type]} [description]
       */
      wallbedPosition(){
        // walbed not loaded yet
        if(this.wallbedBlueprint == null){
          return {
            x:0,
            y:0
          };
        }else{
          // center within container
          const containerHeight = 100;
          const viewBoxWidth = this.viewBoxWidth,
                width = parseFloat(this.wallbedBlueprint.width),
                height = parseFloat(this.wallbedBlueprint.height);
          return {
            x : (viewBoxWidth - width)/2,
            y : (containerHeight - height)/2
          }
        }
      },
      /**
       * calculate x and y position for left cabinet
       * @return {[type]} [description]
       */
      leftCabinetPosition(){
        // no left cabinet
        if(this.leftCabinetBlueprint == null) return {x:0,y:0};
        const width = parseFloat(this.left_cabinet.width),
              height = parseFloat(this.left_cabinet.height),
              wPos = this.wallbedPosition,
              wBlueprint = this.wallbedBlueprint;
        return {
          y : wPos.y + (parseFloat(wBlueprint.height) - height),
          x : (parseFloat(wPos.x) - width)
        };
      },
      /**
       * calculate x and y position for right cabinet
       * @return {[type]} [description]
       */
      rightCabinetPosition(){
        // no right cabinet
        if(this.rightCabinetBlueprint == null) return {x:0,y:0};
        const height = parseFloat(this.right_cabinet.height),
              wPos = this.wallbedPosition,
              wBlueprint = this.wallbedBlueprint;
        return {
          y : wPos.y + (parseFloat(wBlueprint.height) - height),
          x : parseFloat(wPos.x) + parseFloat(wBlueprint.width)
        };
      },
      /**
       * calculate the position for all the elements for the left measurement line
       * measures overall height of the wallbed (+ cabinets)
       * @return {[type]} [description]
       */
      measurementLeft(){
        // calculate main line
        let x = 0,
            y = this.wallbedPosition.y,
            left = 0,
            wallbedHeight = parseFloat(this.wallbedProp('height'));
        // if left cabinet
        
        if(this.leftCabinetBlueprint != null){
          left = this.leftCabinetPosition.x - 4;
        }else{
          left = this.wallbedPosition.x - 4;
        }
        let measurements = {};
        measurements.main = `M ${left} ${y} l 0 ${wallbedHeight}`;
        // calculate top line
        x = left - 1;
        measurements.top = `M ${x} ${y} l 2 0`;
        // calculate bottom line
        y = y + wallbedHeight;
        measurements.bottom = `M ${x} ${y} l 2 0`;
        // calculate location for rect
        measurements.rect = {
          x : left - 2,
          y : this.wallbedPosition.y + (wallbedHeight/2 - 10) // full height of element is 12
        };
        // calculate position for text
        measurements.text = {
          x : left - 4,
          y : measurements.rect.y + 10, // save as rectangle.
        }
        // calculate rotation
        measurements.text.transform = `rotate(-90 ${measurements.text.x},${measurements.text.y})`;

        // total height
        measurements.total = wallbedHeight.toFixed(2);

        return measurements;
      },
      /**
       * calculate the position for all the elements for the bottom measurement line
       * measures overall width of the wallbed (+ cabinets)
       * @return {[type]} [description]
       */
      measurementWidth(){
        let measurements = {},
            left = 0;
        const wallbedHeight = parseFloat(this.wallbedProp('height')),
              wallbedWidth = parseFloat(this.wallbedProp('width')),
              leftWidth = parseFloat(this.leftCabinetProp('width')),
              rightWidth = parseFloat(this.rightCabinetProp('width'));
        // calculate main line      
        let y = this.wallbedPosition.y + wallbedHeight + 4;
        if(this.leftCabinetBlueprint != null){
          left = this.leftCabinetPosition.x;
        }else{
          left = this.wallbedPosition.x;
        }

        let width = wallbedWidth + leftWidth + rightWidth;
        measurements.main = `M ${left} ${y} l ${width} 0`;
        // calculate left line
        measurements.left = `M ${left} ${y - 1} l 0 2`;
        // calculate right line
        measurements.right = `M ${left + width} ${y - 1} l 0 2`;
        // calculate middle rectangle
        measurements.rect = {
          x : left + (width/2 - 10), // full width of element is 12,
          y : y - 2 // full height of element is 4
        };
        // text position.
        measurements.text = {
          x : left + (width/2 - 5),
          y : y + 1, // save as rectangle.
        };
        const total = parseFloat(this.wallbedProp('width')) + 
                      parseFloat(this.leftCabinetProp('width')) + 
                      parseFloat(this.rightCabinetProp('width'));
        measurements.total = total.toFixed(2);

        return measurements;
      },
      /**
       * calculate the position for all the elements for the right measurement line
       * measures heights of the leftCabinetPosition
       * @return {[type]} [description]
       */
      measurementRight(){
        let measurements = {};

        const wallbedWidth = parseFloat(this.wallbedProp('width')),
              rightWidth = parseFloat(this.rightCabinetProp('width')),
              leftHeight = parseFloat(this.leftCabinetProp('height')),
              rightHeight = parseFloat(this.rightCabinetProp('height'));

        // calculate main line
        let left = this.wallbedPosition.x + wallbedWidth + rightWidth + 4,
            y = (this.left_cabinet != null)? this.leftCabinetPosition.y :  this.rightCabinetPosition.y,
            height = (leftHeight > 0 )? leftHeight : rightHeight;
        measurements.main = `M ${left} ${y} l 0 ${height}`;
        // top
        measurements.top = `M ${left - 1 } ${y} l 2 0`;
        // bottom
        measurements.bottom = `M ${left - 1} ${y + height} l 2 0`;
        // rect
        measurements.rect = {
          y : y + (height/2 - 10),
          x : left - 2
        };
        measurements.text = {
          y : y + (height/2),
          x : left - 2,
          transform : ""
        };
        measurements.text.transform = `rotate(-90 ${measurements.text.x},${measurements.text.y})`;
        measurements.total = height.toFixed(2);
        return measurements;
      },
      ...mapState({
        wallbed : state => state.wallbed,
        bed_size : state => state.selected_size,
        left_cabinet : state => state.selected_cabinet_left,
        right_cabinet : state => state.selected_cabinet_right,
        desk_table : state => state.selected_desk_table,
        left_cabinet_glass_doors: state => state.left_cabinet_glass_doors,
        left_cabinet_night_tray: state => state.left_cabinet_night_tray,
        right_cabinet_glass_doors: state => state.right_cabinet_glass_doors,
        right_cabinet_night_tray: state => state.right_cabinet_night_tray,
      })
    }
  };
</script>